"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQualityColumn = void 0;
const BoolCellRenderer_1 = __importDefault(require("../BoolCellRenderer"));
const utils_1 = require("../utils");
const PlantsColumns_1 = require("../Plants/PlantsColumns");
const gridUtils_1 = require("../gridUtils");
const zeroPad = (num, places) => String(num).padStart(places, '0');
function createQualityColumn(customCols, presets) {
    return [
        {
            field: 'botanisch',
            headerName: 'Botanisch',
            checkboxSelection: true,
            headerCheckboxSelection: true,
            cellRenderer: 'agGroupCellRenderer',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'deutsch_kurz@plants',
            headerName: 'Deutsch kurz',
            filter: 'agMultiColumnFilter',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'checked',
            headerName: 'Überprüft',
            editable: false,
            cellRenderer: 'LabelConfirmationGridEditor',
            cellClass: 'booleanType',
            type: 'booleanColumn',
        },
        {
            field: 'tb',
            headerName: 'Tb',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'pg',
            headerName: 'PG',
            cellEditor: 'agRichSelectCellEditor',
            width: 80,
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'pg'),
            },
            type: ['perm_editConfirmedLabel'],
        },
        {
            field: 'ean',
            headerName: 'EAN',
            cellEditor: 'DuplicateTextCellEditor',
            type: ['perm_editConfirmedLabel'],
        },
        {
            field: 'be_art_nr',
            headerName: 'BE-Art.-Nr.',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'pr',
            headerName: 'Präs.Bereich',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'pr'),
            }
        },
        {
            field: 'warengruppe',
            headerName: 'Warengruppe',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'warengruppe'),
            }
        },
        {
            field: 'bluhend@plants',
            headerName: 'Blühend',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'blutezeit_von@plants',
            headerName: 'Blütezeit von',
            valueSetter: (0, gridUtils_1.numericValueSetter)((value) => {
                value = value < 1 ? 1 : value;
                value = value > 12 ? 12 : value;
                return value;
            }),
            filter: 'agNumberColumnFilter',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'blutezeit_bis@plants',
            headerName: 'Blütezeit bis',
            valueSetter: (0, gridUtils_1.numericValueSetter)((value) => {
                value = value < 1 ? 1 : value;
                value = value > 12 ? 12 : value;
                return value;
            }),
            filter: 'agNumberColumnFilter',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'blutezeit_worded@plants',
            headerName: 'Blütezeit',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'hohe_cm@plants',
            headerName: 'Höhe',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'lichtbedarf@plants',
            headerName: 'Lichtbedarf',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'lichtbedarf'),
            }
        },
        {
            field: 'lichtbedarf_etikett',
            headerName: 'Lichtbedarf Etikett',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'lichtbedarf_etikett'),
            }
        },
        {
            field: 'stk_m2@plants',
            headerName: 'Stk / m2',
            type: 'perm_editConfirmedLabel'
        },
        {
            field: 'pflanzabstand_cm@plants',
            headerName: 'Pflanzabstand (cm)',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'text_ruckseite',
            headerName: 'Text Rückseite',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'winterharte',
            headerName: 'Winterhärte',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            width: 80,
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'winterharte'),
            }
        },
        {
            field: 'pflege',
            headerName: 'Pflege',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            width: 80,
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'pflege'),
            }
        },
        {
            field: 'text',
            headerName: 'Text',
            type: 'perm_editConfirmedLabel',
            maxWidth: 600,
            suppressSizeToFit: true,
            cellEditor: 'agLargeTextCellEditor',
            cellEditorParams: {
                maxLength: 65000,
            },
        },
        {
            field: 'ungiftig@plants',
            headerName: 'Ungiftig',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'storer1',
            headerName: 'Störer 1',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            width: 80,
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'storer1'),
            }
        },
        {
            field: 'heimische_wildstaude@plants',
            headerName: 'Heimische Wildstaude',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'wasserbedarf@plants',
            headerName: 'Wasserbedarf',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'wasserbedarf'),
            }
        },
        {
            field: 'wassertiefe_von@plants',
            headerName: 'Wassertiefe von (cm)',
            type: 'perm_editConfirmedLabel',
            valueSetter: (0, gridUtils_1.numericValueSetter)((value) => (0, utils_1.ceilToFive)(value)),
        },
        {
            field: 'wassertiefe_bis@plants',
            headerName: 'Wassertiefe bis (cm)',
            type: 'perm_editConfirmedLabel',
            valueSetter: (0, gridUtils_1.numericValueSetter)((value) => (0, utils_1.ceilToFive)(value)),
        },
        {
            field: 'wasserbedarf_text@plants',
            headerName: 'Wasserbedarf Text',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'besondere_eigenschaften',
            headerName: 'besondere Eigenschaften',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'bienenweide@plants',
            headerName: 'Bienenweide',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'bodendecker@plants',
            headerName: 'Bodendecker',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'dauerbluher@plants',
            headerName: 'Dauerblüher',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'duftstauden@plants',
            headerName: 'Duftstauden',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'schneckenresistent@plants',
            headerName: 'Schneckenresistent',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'trittvertraglich@plants',
            headerName: 'Trittverträglich',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'wintergrun@plants',
            headerName: 'Wintergrün',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'besonderes_individuell',
            headerName: 'Besonderes individuell',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'gefahrenhinweis',
            headerName: 'Gefahrenhinweis',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'gefahrenhinweis'),
            }
        },
        {
            field: 'quickorder',
            headerName: 'Quickorder',
            cellEditor: 'agRichSelectCellEditor',
            width: 80,
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'quickorder'),
            },
        },
        {
            field: 'bild',
            headerName: 'Bild',
            type: ['booleanColumn', 'derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'floramedia_own_picture',
            headerName: 'Eigenes FM-Bild',
            type: ['booleanColumn', 'derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'floramedia_picture_name',
            headerName: 'FM Bild Code',
            headerTooltip: 'Floramedia Bild Code',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'interne_art_nr',
            headerName: 'Interne Art.-Nr.',
            type: 'perm_editConfirmedLabel',
            valueSetter: (0, gridUtils_1.numericValueSetter)((value) => {
                return zeroPad(value, 5);
            }),
        },
        {
            field: 'etikett',
            headerName: 'Etikett',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'etikett'),
            }
        },
        {
            field: 'katalog_schacht',
            headerName: 'K-JS',
            headerTooltip: 'Katalog Schacht',
            type: 'booleanColumn',
        },
        {
            field: 'katalog_fehrle',
            headerName: 'K-FE',
            headerTooltip: 'Katalog Fehrle',
            type: 'booleanColumn',
        },
        {
            field: 'katalog_frikarti',
            headerName: 'K-FR',
            headerTooltip: 'Katalog Frikarti',
            type: 'booleanColumn',
        },
        {
            field: 'katalog_ham',
            headerName: 'K-HA',
            headerTooltip: 'Katalog Ham',
            type: 'booleanColumn',
        },
        {
            field: 'katalog_schwermer',
            headerName: 'K-PS',
            headerTooltip: 'Katalog Schwermer',
            type: 'booleanColumn',
        },
        {
            field: 'katalog_foerster',
            headerName: 'K-FÖ',
            headerTooltip: 'Katalog Foerster',
            type: 'booleanColumn',
        },
        {
            field: 'katalog_schweiss',
            headerName: 'K-RS',
            headerTooltip: 'Katalog Schweiss',
            type: 'booleanColumn',
        },
        {
            field: 'katalog_becker',
            headerName: 'K-BE',
            headerTooltip: 'Katalog Becker',
            type: 'booleanColumn',
        },
        {
            field: 'etik_js',
            headerName: 'Etik-JS',
            headerTooltip: 'Etik Schacht',
            type: 'booleanColumn',
        },
        {
            field: 'etik_fe',
            headerName: 'Etik-FE',
            headerTooltip: 'Etik Fehrle',
            type: 'booleanColumn',
        },
        {
            field: 'etik_fr',
            headerName: 'Etik-FR',
            headerTooltip: 'Etik Frikarti',
            type: 'booleanColumn',
        },
        {
            field: 'etik_ha',
            headerName: 'Etik-HA',
            headerTooltip: 'Etik Ham',
            type: 'booleanColumn',
        },
        {
            field: 'etik_fo',
            headerName: 'Etik-FÖ',
            headerTooltip: 'Etik Foerster',
            type: 'booleanColumn',
        },
        {
            field: 'etik_rs',
            headerName: 'Etik-RS',
            headerTooltip: 'Etik Schweiss',
            type: 'booleanColumn',
        },
        {
            field: 'etik_be',
            headerName: 'Etik-BE',
            headerTooltip: 'Etik Becker',
            type: 'booleanColumn',
        },
        {
            field: 'production_becker',
            headerName: 'Pro-BE',
            headerTooltip: 'Produktion Becker',
            type: ['booleanColumn', 'perCompanyColumn'],
        },
        {
            field: 'production_fehrle',
            headerName: 'Pro-FE',
            headerTooltip: 'Produktion Fehrle',
            type: ['booleanColumn', 'perCompanyColumn'],
        },
        {
            field: 'production_foerster',
            headerName: 'Pro-Fo',
            headerTooltip: 'Produktion Foerster',
            type: ['booleanColumn', 'perCompanyColumn'],
        },
        {
            field: 'production_frikarti',
            headerName: 'Pro-Fri',
            headerTooltip: 'Produktion Foerster',
            type: ['booleanColumn', 'perCompanyColumn'],
        },
        {
            field: 'production_ham',
            headerName: 'Pro-Ham',
            headerTooltip: 'Produktion Hameter',
            type: ['booleanColumn', 'perCompanyColumn'],
        },
        {
            field: 'production_schacht',
            headerName: 'Pro-Schacht',
            headerTooltip: 'Produktion Schachtschneider',
            type: ['booleanColumn', 'perCompanyColumn'],
        },
        {
            field: 'production_schweiss',
            headerName: 'Pro-Schweiss',
            headerTooltip: 'Produktion Schweiss',
            type: ['booleanColumn', 'perCompanyColumn'],
        },
        {
            field: 'schachtschneider_1',
            headerName: 'Schacht-Etiketten',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'schachtschneider_1'),
            }
        },
        {
            field: 'fehrle_1',
            headerName: 'Fehrle_1',
        },
        {
            field: 'greensys',
            headerName: 'Greensys',
            type: 'booleanColumn',
        },
        {
            field: 'wyss',
            headerName: 'Wyss',
            type: 'booleanColumn',
        },
        {
            field: 'frikarti_etiketten',
            headerName: 'Frikarti-Etiketten',
        },
        {
            field: 'frikarti_1',
            headerName: 'Frikarti 1',
        },
        {
            field: 'frikarti_2',
            headerName: 'Frikarti 2',
        },
        {
            field: 'frikarti_3',
            headerName: 'Frikarti 3',
        },
        {
            field: 'frikarti_4',
            headerName: 'Frikarti 4',
            type: 'booleanColumn',
            cellRenderer: BoolCellRenderer_1.default,
        },
        {
            field: 'hameter_1',
            headerName: 'Ham. Präs.',
            type: 'booleanColumn',
        },
        {
            field: 'hameter_3',
            headerName: 'Hameter-Etiketten',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'hameter_3'),
            }
        },
        {
            field: 'created_at',
            headerName: 'Erstellt am',
            type: ['derivedColumn', 'dateColumn'],
        },
        {
            // !hidden
            field: 'created_by',
            headerName: 'Created by',
            type: 'hiddenColumn',
        },
        {
            field: 'created_by_name',
            headerName: 'Erstellt von',
            type: 'derivedColumn',
        },
        {
            field: 'updated_at',
            headerName: 'Aktualisiert am',
            type: ['derivedColumn', 'dateColumn'],
        },
        {
            // !hidden
            field: 'updated_by',
            headerName: 'Updated by',
            type: 'hiddenColumn',
        },
        {
            field: 'updated_by_name',
            headerName: 'Aktualisiert von',
            type: 'derivedColumn',
        },
        {
            field: 'checked_at',
            headerName: 'Überprüft am',
            type: ['derivedColumn', 'dateColumn'],
        },
        {
            field: 'checked_by_name',
            headerName: 'Überprüft von',
            type: 'derivedColumn',
        },
        {
            field: 'id',
            headerName: 'ID intern',
            editable: false,
            suppressMenu: true,
            sortable: true,
            minWidth: 100,
            filter: 'agNumberColumnFilter',
        },
        {
            field: 'plant_id',
            headerName: 'ID Pflanze',
            suppressMenu: true,
            sortable: true,
            minWidth: 100,
            editable: false,
        },
        {
            field: 'package_size',
            headerName: 'Verpkg.gr.',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            width: 80,
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'verpackungsgroessen'),
            }
        },
        {
            field: 'floramedia_art_nr',
            headerName: 'FAN',
            headerTooltip: 'Floramedia Artikel Nummer',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'storer2',
            headerName: 'Störer 2',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            width: 80,
            cellEditorParams: {
                values: (0, PlantsColumns_1.getValuesFromPreset)(presets, 'storer2'),
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: ['Neu', 'in Bearbeitung', 'Fertig'],
            }
        },
        {
            field: 'anmerkung',
            headerName: 'Anmerkung',
        },
        ...(0, utils_1.customColumnsToColDef)(customCols),
        {
            // !hidden
            field: 'label_state',
            type: ['derivedColumn', 'hiddenColumn'],
        },
    ];
}
exports.createQualityColumn = createQualityColumn;
